import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MandatoryStar, getSnackbarSuccess } from "../../../Utils/helper";
import {
    GetAppointmentPayoutDetailsNetworkAction,
    getPayoutCountsNetworkAction,
    PayoutAdjustmentAction,
  } from "../../../redux/actions/PayoutAction";

export const PayoutAdjustment = ({
  searchFilter,
  providerDetail,
  setProviderDetail,
  openModel,
  setOpenModel,
}) => {
  const ref = useRef();
  const [payload, setPayload] = useState({
    adjustmentType: providerDetail[0]?.adjustmentType,
    adjustAmount: providerDetail[0]?.adjustAmount,
    adjustmentRemarks: providerDetail[0]?.adjustmentRemarks,
    adjustedAmount: 0,
    businessType: providerDetail[0]?.businessType,
  });
  console.log("payload checking", payload);
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer?.adjustmentRemarks);

  useEffect(() => {
    let adjustedAmount = parseFloat(providerDetail[0]?.grossAmount) || 0;
    const adjustValue = parseFloat(payload.adjustAmount) || 0;

    if (payload.adjustmentType === "plus") {
      adjustedAmount += adjustValue;
    } else if (payload.adjustmentType === "minus") {
      adjustedAmount -= adjustValue;
    }

    setPayload((payload) => ({
      ...payload,
      adjustedAmount: adjustedAmount.toFixed(2), // Keeping 2 decimal places
    }));
  }, [
    payload.adjustmentType,
    payload.adjustAmount,
    providerDetail[0]?.grossAmount,
    payload.adjustmentRemarks
  ]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    if (event.target.checkValidity()) {
      if (
        payload?.adjustmentType === "minus" &&
        +payload?.adjustAmount > +providerDetail[0]?.grossAmount
      ) {
        getSnackbarSuccess(
          "warning",
          "Adjustment Amount should be less than or equal to Gross Amount",
          dispatch
        );
      } else {
        console.log("payload response", payload)
        console.log("payload response1", providerDetail[0])
        const res = await dispatch(
            PayoutAdjustmentAction({
              appointmentId: providerDetail[0]?.appointmentId,
              providerId: providerDetail[0]?.providerId,
              ...payload
            })
        );
          if (res) {
            console.log("Response",res?.data);
            getSnackbarSuccess("success", res?.data?.message, dispatch);
            setTimeout(()=>{
              dispatch(
                GetAppointmentPayoutDetailsNetworkAction({
                  ...searchFilter,
                  page: 1,
                  rows: 10,
                  IsPayoutStatus: true,
                })
              );
              dispatch(getPayoutCountsNetworkAction({ ...searchFilter, page: 1 }));
            },2000)
            handleClose();
          }
      }
    }
  };

  const handleClose = () => {
    setOpenModel({ ...openModel, adjustAmount: false });
    setProviderDetail([0]);

    console.log("adjustAmount", openModel);
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black ">Adjustment</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose()}
        ></button>
      </div>

      <form
        ref={ref}
        className="form-admin"
        style={{ overflowX: "hidden" }}
        onSubmit={handleSubmit}
        noValidate
      >
        <div className="modal-body">
          <div className="row ">
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">Case Number</label>
              <input
                name="caseNo"
                type="text"
                disabled
                style={{ backgroundColor: "#EEEEEE" }}
                value={providerDetail[0]?.caseNo}
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
              />
            </div>
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">Gross Amount</label>
              <input
                name="ProviderAmount"
                type="text"
                disabled
                style={{ backgroundColor: "#EEEEEE" }}
                value={providerDetail[0]?.grossAmount}
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
              />
            </div>
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">Adjustment Type</label>
              <MandatoryStar />
              <select
                name="AdjustmentType"
                className="form-select"
                style={{ height: "40px" }}
                required
                value={payload?.adjustmentType}
                onChange={(e) => {
                  setPayload({ ...payload, adjustmentType: e.target.value });
                }}
              >
                <option value="">Select Type</option>
                <option value="plus">Plus</option>
                <option value="minus">Minus</option>
              </select>
            </div>
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">
                Adjustment Amount
                <MandatoryStar />
              </label>
              <input
                name="adjustAmount"
                type="number"
                placeholder="Enter Here..."
                value={payload?.adjustAmount}
                onKeyPress={(e) => {
                  const value = e.target.value;
                  const allowedChars = /^[0-9\b.]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }

                  // Check if the input already contains a decimal point
                  if (e.key === "." && value.includes(".")) {
                    e.preventDefault();
                  }

                  // Check if the input is going to exceed two decimal places
                  if (
                    value.includes(".") &&
                    value.split(".")[1].length >= 2 &&
                    e.key !== "Backspace"
                  ) {
                    e.preventDefault();
                  }
                }}
                min={1}
                className="form-control form-select-admin inputbgavanish"
                required
                onChange={(e) => {
                  setPayload({ ...payload, adjustAmount: e.target.value });
                }}
              />
            </div>
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">Adjusted Amount</label>
              <input
                name="adjustedAmount"
                type="number"
                disabled
                value={payload?.adjustedAmount}
                onChange={(e) => {
                  setPayload({ ...payload, adjustedAmount: e.target.value });
                }}
                className="form-control form-select-admin inputbgavanish"
              />
            </div>
            <div className="col-lg-12 col-md-12 mt-2">
              <label className="col-form-label">
                Remarks
                <MandatoryStar />
              </label>
              <textarea
                className="form-control form-select-admin inputbgavanish"
                rows="3"
                cols="33"
                style={{ border: "1px solid #eeeeee", borderRadius: "5px" }}
                value={payload?.adjustmentRemarks}
                onKeyPress={(e) => {
                  const re = /^[a-zA-Z\s]*$/;
                  if (e.target.value.trim() === "" && e.key === " ") {
                    e.preventDefault();
                    return;
                  }
                }}
                required
                onChange={(e) =>
                  setPayload({ ...payload, adjustmentRemarks: e.target.value })
                }
              ></textarea>
            </div>
          </div>
        </div>

        <div className="modal-footer modal-footer-admin  bottom-0  mt-4">
          <div className="d-flex justify-content-end flex-wrap gap-10">
            <button
              onClick={() => handleClose()}
              type="button"
              className="savedetails"
            >
              Cancel
            </button>
            <button type="submit" className="savedetails">
              {"Update"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};
